import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";

export const useGetAllClaimSettlementTypeService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const [claimSettlementTypeSearchQuery, setClaimSettlementTypeSearchQuery] =
    useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(
    claimSettlementTypeSearchQuery
  );

  const allClaimSettlementTypeService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CLAIM_SETTLEMENT_TYPE,
      page,
      per_page,
      debouncedQuery,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.CLAIM_SETTLEMENT_TYPE,
        searchParams: {
          page,
          per_page,
          "filter[name]": debouncedQuery,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });
  return {
    service: { allClaimSettlementTypeService },
    state: {
      claimSettlementTypeSearchQuery,
      setClaimSettlementTypeSearchQuery,
    },
  };
};
